/**
 * Capitalize first letter of string
 */
export function capitalizeFirstLetter(iString) {
  if (iString?.length > 1) {
    return iString.charAt(0).toUpperCase() + iString.slice(1).toLowerCase();
  }
  else {
    return iString? iString.toUpperCase(): "";
  }
}
